import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RiesgoLiquidezRoutingModule } from './riesgo-liquidez-routing.module';
import { ConcentracionComponent } from './concentracion/concentracion.component';
import { MayoresDepositantesComponent } from './mayores-depositantes/mayores-depositantes.component';
import { SharedModule } from '../../shared/shared.module';
import { GapComponent } from './gap/gap.component';
import { CoberturaRCLComponent } from './cobertura-rcl/cobertura-rcl.component';
import { GapAiracComponent } from './gap-airac/gap-airac.component';
import { RazonesLiquidezComponent } from './razones-liquidez/razones-liquidez.component';
import { CalcesPlazosComponent } from './calces-plazos/calces-plazos.component';
import { VolatilidadComponent } from './volatilidad/volatilidad.component';


@NgModule({
  declarations: [
    ConcentracionComponent,
    MayoresDepositantesComponent,
    GapComponent,
    CoberturaRCLComponent,
    GapAiracComponent,
    RazonesLiquidezComponent,
    CalcesPlazosComponent,
    VolatilidadComponent
  ],
  imports: [
    CommonModule,
    RiesgoLiquidezRoutingModule,
    SharedModule
  ]
})
export class RiesgoLiquidezModule { }
